export default __webpack_public_path__ + "static/llm-9d50c9bc0ceb7eb843c6947552d564a7.jpg";